//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import BaseComponent from '../base'
import Field from "../common/Field";
import i18 from "../../i18";
import Validator from "../common/Validator";
import api from "../../source/api";
import NotificationSystem from "react-notification-system";
import PATH from "../../config/dev";
import {Link} from "react-router-dom";

const CUSTOMER = 'customer';
const SUPPLIER = 'supplier';
const MIXED = 'mixed';

class Mixed extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            company: {},
            fields: {
                inputFileCustomer: {value: '', error: '', role: {required: true}},
                inputFileSupplier: {value: '', error: '', role: {required: true}},
                inputFileMixed: {value: '', error: '', role: {required: true}},
            },
            error: null,
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            company: nextProps.company,
        });
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'mixed/init?company_id=' + this.props.location.match.params.id}, true).then((response) => {
            if (response.status === 200) {
                this.setState({
                    company: response.data.company,
                })
            }
        })
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    upload = (type) => {
        let fields = this.state.fields;
        fields.inputFileCustomer.role.required = type === CUSTOMER;
        fields.inputFileSupplier.role.required = type === SUPPLIER;
        fields.inputFileMixed.role.required = type === MIXED;
        fields.inputFileCustomer.error = '';
        fields.inputFileSupplier.error = '';
        fields.inputFileMixed.error = '';

        let validator = Validator.validate(fields)
        this.setState({
            fields: validator.fields,
            error: validator.error
        });

        if (this.state.error) {
            return;
        }

        document.body.classList.toggle('loading-body', true)
        this.setState({processing: true})


        api.postFile({url: 'mixed/upload?company_id=' + this.state.company.id, data: this.collectFormData(type)}, true).then((response) => {
            if (response.status === 200) {
                this.setState({processing: false})
                document.body.classList.remove('loading-body')
                window.open(PATH.ENDPOINT_BASE_URL + 'mixed/download'
                    + '?auth_token=' + api.getToken()
                    + '&company_id=' + this.state.company.id
                    + '&fileName=' + response.data.fileName
                )

            }
        }).catch((err) => {
            document.body.classList.remove('loading-body')
            this.setState({processing: false})
            this._addNotification(err.response.data.error.message, 'error')
        })
    }

    collectFormData = (type) => {
        let form = new FormData();
        if (type === CUSTOMER) {
            form.append('inputFile', document.querySelector('#inputFileCustomer').files[0])
        } else if (type === SUPPLIER) {
            form.append('inputFile', document.querySelector('#inputFileSupplier').files[0])
        } else {
            form.append('inputFile', document.querySelector('#inputFileMixed').files[0])
        }
        form.append('type', type)

        return form
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    }

    render() {
        return (
            <section id='mixed-upload'>
                <div className='header'>
                    <div className='container'>
                        <h1 className='margin-bottom-50'>Excel alapú adat  betöltés</h1>
                        <p>A demo file-t le kell tölteni, majd adatokkal kitölteni. Ezek után a Beeker átkonvertálja a könyvelőprogramba betölthető állományra.</p>
                        <div className="row" style={{marginBottom: "50px"}}>
                            <div className="col-md-12">
                                <div className="pull-left">
                                    <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : ''} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="upload-body"  style={{marginBottom: "200px"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <table className='table table-aibook-bordered'>
                                    <thead>
                                    <tr>
                                        <th style={{width: '35%'}}>Megnevezés</th>
                                        <th style={{width: '35%'}}>Bemeneti állomány</th>
                                        <th style={{width: '15%'}}>Művelet</th>
                                        <th style={{width: '15%'}}>Demo</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Bemenet átalakítása vevő fiókhoz</td>
                                        <td className='text-center'>
                                            <Field
                                                type="file"
                                                id="inputFileCustomer"
                                                name="inputFileCustomer"
                                                fileUploadEndpoint=""
                                                classLabel="control-label"
                                                classInput="file-input"
                                                setValue={this.setValue.bind(this)}
                                                state={this.state}
                                            />
                                        </td>
                                        <td className='text-center'>
                                            <a
                                                onClick={() => this.upload(CUSTOMER)}
                                                className={this.state.processing ? 'disabled next-step' : 'next-step'}
                                            >
                                                Feltöltés
                                            </a>
                                        </td>
                                        <td className='text-center'>
                                            <a href='/letoltesek/Vegyes-demo-vevo.xlsx' className='table-green-btn mr-3' target='_blank'>Demo</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Bemenet átalakítása szállító fiókhoz</td>
                                        <td className='text-center'>
                                            <Field
                                                type="file"
                                                id="inputFileSupplier"
                                                name="inputFileSupplier"
                                                fileUploadEndpoint=""
                                                classLabel="control-label"
                                                classInput="file-input"
                                                setValue={this.setValue.bind(this)}
                                                state={this.state}
                                            />
                                        </td>
                                        <td className='text-center'>
                                            <a
                                                onClick={() => this.upload(SUPPLIER)}
                                                className={this.state.processing ? 'disabled next-step' : 'next-step'}
                                            >
                                                Feltöltés
                                            </a>
                                        </td>
                                        <td className='text-center'>
                                            <a href='/letoltesek/Vegyes-demo-szallito.xlsx' className='table-green-btn mr-3' target='_blank'>Demo</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Bemenet átalakítása vegyes fiókhoz</td>
                                        <td className='text-center'>
                                            <Field
                                                type="file"
                                                id="inputFileMixed"
                                                name="inputFileMixed"
                                                fileUploadEndpoint=""
                                                classLabel="control-label"
                                                classInput="file-input"
                                                setValue={this.setValue.bind(this)}
                                                state={this.state}
                                            />
                                        </td>
                                        <td className='text-center'>
                                            <a
                                                onClick={() => this.upload(MIXED)}
                                                className={this.state.processing ? 'disabled next-step' : 'next-step'}
                                            >
                                                Feltöltés
                                            </a>
                                        </td>
                                        <td className='text-center'>
                                            <a href='/letoltesek/Vegyes-demo-vegyes.xlsx' className='table-green-btn mr-3' target='_blank'>Demo</a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Mixed


// WEBPACK FOOTER //
// ./src/components/Mixed/Mixed.js